import { mockBuilder } from '../utils/builderHelper.es.js';
import { generateId } from '../utils/generateId.es.js';
import { Collaborator } from './Collaborator.es.js';
import { aUser } from './User.mock.es.js';

/** @module Mocks */ /** typedoc */
function aCollaborator() {
    return mockBuilder(new Collaborator(generateId('collaborator', 0), generateId('user', 0), 'test@landr.com', aUser(), false, '2018-01-01T12:00:00.0000Z'));
}

export { aCollaborator };
